export enum EmailTaskStatus {
    Pending = "Pending",
    Sending = "Sending",
    Sent = "Sent",
    Error = "Error",
}

export interface EmailQueuerTask {
    id: number;
    to: string;
    cc: string;
    bcc: string;
    attachmentPaths: string;
    subject: string;
    modelJson: string;
    template: string;
    modelType: string;
    status: EmailTaskStatus;
    createdOn: Date;
    sentOn: Date;
}
